import styled from 'styled-components';
import { MediaQueries } from 'ratel-ui';

export const Container = styled.div`
  padding: 29px 98px;
  font-family: "Rubik", sans-serif;
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 32px;
  background-color: #000;
  position: relative;

  ${MediaQueries.mobileTablet`
    padding: 20px 32px;
    gap: 20px;
  `}

  ${MediaQueries.mobile`
    padding: 16px 20px;
    gap: 12px;
  `}
`;

export const Logo = styled.img`
  width: 150px;
  height: 65px;
  object-fit: contain;
  flex-shrink: 0;

  ${MediaQueries.mobileTablet`
    width: 110px;
    height: 48px;
  `}

  ${MediaQueries.mobile`
    width: 84px;
    height: 36px;
  `}
`;

export const HeaderTitle = styled.h1`
  margin: 0;
  margin-top: 10px;
  font-size: 42px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0;

  ${MediaQueries.mobileTablet`
    margin-top: 6px;
    font-size: 30px;
  `}

  ${MediaQueries.mobile`
    margin-top: 4px;
    font-size: 22px;
  `}
`;